import { Paper, Tabs } from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import { PageContent } from "../BuildingBlocks/Layout/PageContent/PageContent";
import { PageHeader } from "../BuildingBlocks/Layout/PageHeader/PageHeader";
import { PPAContractPage } from "./PPAContractPage/PPAContractPage";
import { PPAInvoiceNumberRangesPage } from "./PPAInvoiceNumberRangesPage/PPAInvoiceNumberRangesPage";
import { PPAInvoicePage } from "./PPAInvoicesPage/PPAInvoicePage";

export const TABS = {
  CONTRACTS: "vertraege",
  INVOICES: "rechnungen",
  INVOICE_NUMBER_RANGES: "rechnungsnummernkreise"
} as const;

export const DEFAULT_SUBPAGE = TABS.CONTRACTS;

function PPAInvoicingView() {
  const { tab: activeTab } = useParams();
  const navigate = useNavigate();

  return (
    <PageContent className="PPAInvoicingView">
      <PageHeader title="PPA - Abrechnung" />
      <Paper>
        <Tabs value={activeTab} onChange={(newTab) => navigate(`../${newTab}`)}>
          <Tabs.List>
            <Tabs.Tab value={TABS.CONTRACTS}>Verträge</Tabs.Tab>
            <Tabs.Tab value={TABS.INVOICES}>Rechnungen</Tabs.Tab>
            <Tabs.Tab value={TABS.INVOICE_NUMBER_RANGES}>
              Rechnungsnummernkreise
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value={TABS.CONTRACTS}>
            <PPAContractPage />
          </Tabs.Panel>
          <Tabs.Panel value={TABS.INVOICES}>
            <PPAInvoicePage />
          </Tabs.Panel>
          <Tabs.Panel value={TABS.INVOICE_NUMBER_RANGES}>
            <PPAInvoiceNumberRangesPage />
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </PageContent>
  );
}

export { PPAInvoicingView as PPAInvoicingView };
